import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Snackbar from '@material-ui/core/Snackbar'
import Activator from './Activator'

export default class AppProgressLoadable extends Component {
  static propTypes = {
    loader: PropTypes.any,
  }

  state = {
    snackbarClosed: false
  }

  handleSnackbarClose = () => {
    this.setState({ snackbarClosed: true })
  }

  render() {
    const { loader } = this.props
    const { snackbarClosed } = this.state

    if (loader.isPending) {
      return (<Activator />)
    }

    if (loader.isFailed) {
      return (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={!snackbarClosed}
          message={loader.error.message}
          onClose={this.handleSnackbarClose}
        />
      )
    }

    return null
  }
}
